import { Icon } from "./Icon.tsx";

/** Expand/collapse indicator — points right collapsed, rotates down expanded. */
export function ChevronIcon({ expanded }: { expanded: boolean }) {
  return (
    <span
      style={{
        display: "inline-flex",
        transform: expanded ? "rotate(90deg)" : "none",
        transition: "transform 0.15s",
      }}
    >
      <Icon>
        <path d="M9 6l6 6-6 6" />
      </Icon>
    </span>
  );
}
